/*
 * @Author: chenchaoqiang@leedarson.com
 * @Date: 2022-08-09 09:18:17
 * Copyright 2022 Leedarson, All Rights Reserved.
 */
// import AES from 'crypto-js/aes';
// import Pkcs7 from 'crypto-js/pad-pkcs7';
// import CryptoJSCore from 'crypto-js/core';

const AES = require('crypto-js/aes');
const Pkcs7 = require('crypto-js/pad-pkcs7');
const CryptoJSCore = require('crypto-js/core');

const salt = CryptoJSCore.enc.Utf8.parse('1MA0D9C3V3040A9D'); // 目前自定义
const iv = CryptoJSCore.enc.Utf8.parse('1346A5Z7CN8H9GF0');
/*
 * message 字符串
 * AES 加密
 * salt 密钥
 * iv 偏移量
 * mode cbc 模式
 * padding Pkcs7 填充方式
 */
const encrypt = (message: string) => {
  try {
    if (!message) {
      return message;
    }
    const encrypted = AES.encrypt(message, salt, {
      iv,
      mode: CryptoJSCore.mode.CBC,
      padding: Pkcs7,
    });
    return encrypted.toString();
  } catch (err) {
    return '';
  }
};
/*
 * AES 解密
 */
const decrypt = (message: string) => {
  try {
    if (!message) {
      return message;
    }
    const decrypted = AES.decrypt(message, salt, {
      iv,
      mode: CryptoJSCore.mode.CBC,
      padding: Pkcs7,
    });
    return decrypted.toString(CryptoJSCore.enc.Utf8);
  } catch (err) {
    return '';
  }
};

export { encrypt, decrypt };
